//@ts-nocheck
import { useController } from 'react-hook-form';
import { useAssetTables, useAssetTypes } from '@/hooks/api/useAssets';
import { useMemo } from 'react';
import { AssetSelector } from '../AssetSelector';
import { FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { useMapLayerConfigs } from '@/hooks/api/useMapLayers';

export const ProjectTypeAssetForm = ({ control, name }) => {
  const { field } = useController({ control, name });
  const selectedTypes = Array.isArray(field.value) ? field.value : [];

  // const { assetTables } = useAssetTables();
  const { data: layers } = useMapLayerConfigs();

  const allLayers = useMemo(() => {
    if (!layers?.length) return [];

    return layers.map((layer) => {
      return {
        id: layer.id,
        name: layer.displayName,
      };
    });
  }, [layers]);

  const { available, selected } = useMemo(() => {
    const availableList = allLayers.filter(
      (layer) => !selectedTypes.includes(layer.id),
    );

    const selectedList = allLayers.filter((layer) =>
      selectedTypes.includes(layer.id),
    );

    return {
      available: availableList,
      selected: selectedList,
    };
  }, [allLayers, selectedTypes]);

  const handleAdd = (layerId: string) => {
    // Add the new ID to the array and update RHF
    field.onChange([...selectedTypes, layerId]);
  };

  const handleRemove = (layerId: string) => {
    // Filter out the removed ID and update RHF
    field.onChange(selectedTypes.filter((id) => id !== layerId));
  };

  return (
    <FormItem>
      <AssetSelector
        available={available}
        selected={selected}
        onAdd={handleAdd}
        onRemove={handleRemove}
      />
      <FormMessage />
    </FormItem>
  );
};
